//export const APP_URL = "http://ahmed25800-001-site1.ctempurl.com/";
export const APP_URL = "https://localhost:5421/";
